import { useEffect, useRef } from "react";

export function useScrollAnim({
  selector = ".observe",
  threshold = 0.3,
  root = null,
  rootMargin = "0px",
  once = true,
} = {}) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            if (once) obs.unobserve(entry.target);
          } else if (!once) {
            entry.target.classList.remove("show");
          }
        });
      },
      { root, rootMargin, threshold }
    );

    const targets = containerRef.current.querySelectorAll(selector);
    targets.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [selector, threshold, root, rootMargin, once]);

  return containerRef;
}
